


export default function getSavedState(key) {
    if (getStateLocalStorage('auth.currentSession') == null) {
        return JSON.parse('[]')
    }
    key = JSON.parse(getStateLocalStorage('auth.currentSession')).user.username + '.' + key
    return JSON.parse(getStateLocalStorage(key))
}

export function saveState(key, state) {
    key = JSON.parse(getStateLocalStorage('auth.currentSession')).user.username + '.' + key
    window.localStorage.setItem(key, JSON.stringify(state))
}

export function removeFromStorage(key, item) {
    let records = getSavedState(key).filter((x) => { return String(x.key) !== String(item) })
    saveState(key, records)
}

import * as CryptoJS from 'crypto-js'

export function encrypt(value) {
    if (value !== "" && value !== null) {
        const ciphertext = CryptoJS.AES.encrypt(
            value,
            process.env.VUE_APP_LOCALSTORAGE_KEY_SECRET
        ).toString();
        return ciphertext;
    }
};

export function decrypt(value) {
    if (value !== "" && value !== null) {
        const decryptData = CryptoJS.AES.decrypt(
            value,
            process.env.VUE_APP_LOCALSTORAGE_KEY_SECRET
        ).toString(CryptoJS.enc.Utf8);
        return decryptData;
    }
};

function getStateLocalStorage(key) {
    let storage = window.localStorage.getItem(key)
    if (storage != null) {
        if (typeof (storage) == Object && storage.length < 0) {
            return "[]"
        }
        //return decrypt(window.localStorage.getItem(key))
        return storage
    } else {
        return null
    }

}

export function saveStateLocalStorage(key, state) {
    window.localStorage.setItem(key + "_xy", encrypt(JSON.stringify(state)))
}